import { nativeEvents } from '../../globals/events/jquery-events-proxy';
export default {
    storageKey: 'mage-cache-storage',
    data: {},

    init() {
        this.initStorageData();
        this.listenStoreUpdates();
    },

    initStorageData() {
        const cachedData = this.getCachedData();

        this.setStorageData(cachedData);
    },

    getCachedData() {
        try {
            return JSON.parse(localStorage.getItem('mage-cache-storage'));
        } catch (error) {
            console.log(error);
            return {};
        }
    },

    setStorageData(payload) {
        this.data = { ...payload };
    },

    getStorageData() {
        const payload = JSON.parse(localStorage.getItem('mage-cache-storage'));

        if (!payload) return {};

        return payload;
    },

    listenStoreUpdates() {
        const updateHandler = () => {
            setTimeout(() => {
                this.initStorageData();
            }, 0);
        };
        window.addEventListener(nativeEvents.customerDataReload, updateHandler);
    }
};
